export default "__VITE_ASSET__Dpaw56A$__"